var map = {
	"./amazon.svg": 903,
	"./archive_org.svg": 904,
	"./arrow-left.svg": 905,
	"./arrow-outline-down.svg": 906,
	"./arrow-right.svg": 907,
	"./bell.svg": 908,
	"./book.svg": 909,
	"./bookshelf.svg": 910,
	"./caret-down.svg": 911,
	"./caret.svg": 912,
	"./chefshat.svg": 913,
	"./chefshat_outlined.svg": 914,
	"./circletick-outline.svg": 915,
	"./circletick-solid.svg": 916,
	"./closed-padlock.svg": 917,
	"./cog.svg": 918,
	"./collections-outline.svg": 919,
	"./collections-solid.svg": 920,
	"./dots.svg": 921,
	"./envelope.svg": 922,
	"./error-outline.svg": 923,
	"./facebook-grey.svg": 924,
	"./facebook.svg": 925,
	"./favourite.svg": 926,
	"./feature-outline.svg": 927,
	"./feature-solid.svg": 928,
	"./filter.svg": 929,
	"./gift.svg": 930,
	"./grid.svg": 931,
	"./help.svg": 932,
	"./home-outline.svg": 933,
	"./home.svg": 934,
	"./info-outline.svg": 935,
	"./instagram-grey.svg": 936,
	"./instagram.svg": 937,
	"./list-add.svg": 938,
	"./list.svg": 939,
	"./magnifier.svg": 940,
	"./native-share.svg": 941,
	"./opened-padlock.svg": 942,
	"./pinterest.svg": 943,
	"./plus.svg": 944,
	"./printer.svg": 945,
	"./push-pin-filled.svg": 946,
	"./push-pin.svg": 947,
	"./restaurant.svg": 948,
	"./search.svg": 949,
	"./tick.svg": 950,
	"./twitter-grey.svg": 951,
	"./twitter.svg": 952,
	"./voice.svg": 953,
	"./x-big.svg": 954,
	"./x.svg": 955
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 902;